import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/feature/SEOMeta';

export default function Home() {
  const [visibleCount, setVisibleCount] = useState(6);
  const [heroLoaded, setHeroLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setHeroLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const hotArticles = articles.slice(0, visibleCount);
  const featuredCategories = categories.slice(0, 3);

  const websiteStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '五一吃瓜网',
    url: 'http://xjqkfyv.cn/',
    description: '五一吃瓜网官网最新地址一键直达，每日更新全国吃瓜群众聚集的爆料基地。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://xjqkfyv.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '五一吃瓜网',
    url: 'http://xjqkfyv.cn/',
    logo: 'http://xjqkfyv.cn/logo.png',
    description: '全国吃瓜群众聚集的爆料基地，每日更新网红黑料、明星秘闻、社会热点。',
  };

  const webpageStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '五一吃瓜网 - 五一吃瓜网官网 - 最新地址发布页',
    url: 'http://xjqkfyv.cn/',
    description: '五一吃瓜网官网最新地址一键直达，每日更新全国吃瓜群众聚集的爆料基地。',
    publisher: {
      '@type': 'Organization',
      name: '五一吃瓜网',
    },
    datePublished: '2026-07-02',
    dateModified: '2026-07-02',
  };

  return (
    <>
      <SEOMeta
        title="五一吃瓜网 - 五一吃瓜网官网 - 最新地址发布页 | 五一每日吃瓜不打烊入口"
        description="五一吃瓜网官网最新地址一键直达，每日更新全国吃瓜群众聚集的爆料基地。网红黑料、明星秘闻、社会热点反转不断，深夜吃瓜不打烊，火速获取最新入口，吃瓜基地欢迎你！"
        keywords="五一吃瓜网,五一吃瓜官网网页版,五一吃瓜最新地址,吃瓜不打烊,网红黑料,娱乐八卦,每日吃瓜,入口直达"
        canonical="http://xjqkfyv.cn/"
        structuredData={[websiteStructuredData, organizationStructuredData, webpageStructuredData]}
      />

      <Navbar />

      <header className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20night%20city%20scape%20with%20neon%20signs%20and%20warm%20amber%20street%20lights%2C%20crowded%20entertainment%20district%2C%20cinematic%20atmosphere%2C%20moody%20dark%20tones%20with%20warm%20highlights%2C%20editorial%20photography%2C%20high%20contrast&width=1600&height=700&seq=hero-main-01&orientation=landscape"
          alt="五一吃瓜网 - 吃瓜群众爆料基地"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
        <div className={`absolute inset-0 flex flex-col items-center justify-center text-center px-4 transition-all duration-700 ${heroLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading mb-4 leading-tight">
            五一吃瓜网
          </h1>
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mb-6 font-light">
            每日更新全国吃瓜群众聚集的爆料基地
            <br className="hidden md:block" />
            网红黑料、明星秘闻、社会热点反转不断
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/mingxing-bagua"
              className="bg-accent-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium flex items-center gap-2 hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              开始吃瓜
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/about"
              className="bg-white/10 backdrop-blur-sm text-white border border-white/30 px-6 py-3 rounded-full text-sm font-medium hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </header>

      <main className="w-full">
        <section className="bg-background-100 px-4 md:px-8 lg:px-12 py-12 md:py-16">
          <div className="max-w-6xl mx-auto">
            <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider mb-2">
              热门分类
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-8 md:mb-10">
              探索精彩瓜田
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredCategories.map((cat, index) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-xl p-5 md:p-6 hover:shadow-lg transition-all duration-300"
                  style={{ transitionDelay: `${index * 50}ms` }}
                >
                  <div className="w-10 h-10 flex items-center justify-center mb-4">
                    <i className={`ri-${index === 0 ? 'star-smile' : index === 1 ? 'vidicon' : 'fire'}-line text-xl text-foreground-900`} />
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-accent-500 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-xs text-accent-500">
                    <span>{cat.articleCount} 篇爆料</span>
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-8 lg:px-12 py-12 md:py-16">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-10 gap-4">
              <div>
                <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground-500 font-heading">
                  本周最热
                </h2>
                <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading italic">
                  吃瓜群众都在看
                </h3>
              </div>
              <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
                精选全网最劲爆的爆料内容，明星八卦、网红翻车、社会热点一网打尽，吃瓜就要吃最新鲜的。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {hotArticles.map((article, index) => (
                <article
                  key={article.id}
                  className="group bg-background-50 rounded-2xl overflow-hidden hover:shadow-lg transition-all duration-300"
                >
                  <Link to={`/article/${article.slug}`} className="block">
                    <div className="relative h-48 md:h-56 overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        title={`${article.title} | 五一吃瓜网`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                    </div>
                    <div className="p-4 md:p-5">
                      <span className="inline-block bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-md mb-3">
                        {article.categoryName}
                      </span>
                      <h4 className="text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-accent-500 transition-colors line-clamp-3">
                        {article.title}
                      </h4>
                      <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                        <span>{article.publishedAt}</span>
                        <span className="w-1 h-1 rounded-full bg-foreground-300" />
                        <span>{article.readTime}阅读</span>
                        <span className="w-1 h-1 rounded-full bg-foreground-300" />
                        <span>{(article.views / 10000).toFixed(1)}万阅读</span>
                      </div>
                    </div>
                  </Link>
                </article>
              ))}
            </div>

            {visibleCount < articles.length && (
              <div className="text-center mt-8 md:mt-10">
                <button
                  onClick={() => setVisibleCount((prev) => Math.min(prev + 3, articles.length))}
                  className="bg-primary-500 text-background-50 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  加载更多爆料
                </button>
              </div>
            )}
          </div>
        </section>

        <section className="bg-background-100 px-4 md:px-8 lg:px-12 py-12 md:py-16">
          <div className="max-w-6xl mx-auto">
            <div className="bg-primary-500 rounded-2xl p-6 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-background-50 font-heading mb-2">
                  加入吃瓜大家庭
                </h2>
                <p className="text-sm text-background-200 leading-relaxed">
                  每日更新不打烊，第一时间获取最新爆料资讯，吃瓜群众永远在线。
                </p>
              </div>
              <Link
                to="/about"
                className="bg-background-50 text-primary-500 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-accent-100 transition-colors whitespace-nowrap shrink-0"
              >
                了解我们
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
